import React from "react";

import Breadcrumbs from "../../../../components/BreadCrumbs";
import { UIPageFormFooter, UITextField } from "../../../../components/ui";
import PermissionsMatrix from "../../../Company-portal/TeamsPermissions/CreateRole/PermissionsMatrix";
import useAdminCreateRole from "../hooks/useAdminCreateRole";

import "../../../Company-portal/TeamsPermissions/CreateRole/CreateRole.scss";

const AdminCreateRole = () => {
  const {
    copy,
    breadcrumbList,
    name,
    setName,
    setNameTouched,
    permissions,
    setPermissions,
    showNameError,
    creating,
    goBackToList,
    handleSubmit,
    trimmedName,
  } = useAdminCreateRole();

  return (
    <div className="team-management create-role">
      <div className="mt-2">
        <Breadcrumbs list={breadcrumbList} BreadCrumbHasBackIcon={false} />
        <p className="create-role__subtitle">{copy.subtitle}</p>
      </div>

      <div>
        <UITextField
          label={copy.roleNameLabel}
          name="roleName"
          required
          value={name}
          placeholder={copy.roleNamePlaceholder}
          onChange={(event) => setName(event.target.value)}
          onBlur={() => setNameTouched(true)}
          error={showNameError}
          helperText={showNameError ? copy.roleNameRequired : null}
          classNames={{ root: "create-role__name-field mb-24" }}
        />

        <PermissionsMatrix
          value={permissions}
          onChange={setPermissions}
          copy={copy}
        />
      </div>

      <UIPageFormFooter
        cancelLabel={copy.cancel}
        submitLabel={copy.submit}
        onCancel={goBackToList}
        onSubmit={handleSubmit}
        cancelDisabled={creating}
        submitDisabled={!trimmedName || creating}
        submitLoading={creating}
      />
    </div>
  );
};

export default AdminCreateRole;
